import { CourseEnrollment } from '@/models/CourseEnrollment';

export const wasApprovedOnCourse = (course: CourseEnrollment) =>
    course.status === 'COMPLETED' || course.status === 'PASSED';
